import { error } from 'core/components/Notify';
import { useAuth } from 'core/context/AuthContext/AuthContextProvider';
import { PAGE_SIZE } from 'core/utils/constants';
import ErrorMessage from 'core/utils/constants/ErrorMessage';
import httpclient from 'libs/Axios';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useFetchClassList = (list, setlist, notCall?, addIdInUrl?) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const authData = useAuth();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    if(authData?.BRANCH_ID !== undefined){
      const request = async () => {
        setIsLoading(true);
        const response = await httpclient().get(
          `/data/class/list/${authData?.BRANCH_ID}?${PAGE_SIZE}`);
        const data = response?.data?.data?.ClassList || [];
        if(!data?.length && !!response) {
          // error("Class Not Found !",true);
          error(<ErrorMessage basicPath='class' />, true);
        }
        if (addIdInUrl && !searchParams?.get('classid')) {
          searchParams.set('classid', String(data?.[0]?.CLASS_ID));
          setSearchParams(() => searchParams);
        }
        setlist(data);
        setIsLoading(false)
      };
      try {
        if (!notCall) {
          setTimeout(() => {
            request();
          },100)
        }
      } catch(err) {
        console.log(err)
      }
    }
  }, [authData?.BRANCH_ID, notCall]);
  return isLoading;
};
